import api from '../../../utils/api';

export const featureService = {
  async getFeatures() {
    try {
      const response = await api.get('/features/');
      return response.data;
    } catch (error) {
      console.error('Failed to fetch features:', error);
      throw error;
    }
  },

  async createFeature(featureData) {
    try {
      const response = await api.post('/features/', featureData);
      return response.data;
    } catch (error) {
      console.error('Failed to create feature:', error);
      throw error;
    }
  },

  async updateFeature(featureId, featureData) {
    try {
      const response = await api.put(`/features/${featureId}/`, featureData);
      return response.data;
    } catch (error) {
      console.error('Failed to update feature:', error);
      throw error;
    }
  },

  async deleteFeature(featureId) {
    try {
      await api.delete(`/features/${featureId}/`);
      return true;
    } catch (error) {
      console.error('Failed to delete feature:', error);
      throw error;
    }
  },

  async calculateGeometry(geometryData) {
    try {
      const response = await api.post('/calculate/', geometryData);
      return response.data;
    } catch (error) {
      console.error('Failed to calculate geometry:', error);
      throw error;
    }
  },
};
